// extracted by mini-css-extract-plugin
export default {"MyConfirmation":"MyConfirmation_MyConfirmation__rPF4j"};